// SearchAndFilter.tsx
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useAppSelector as useSelector } from "../../../../store";
import CentersFilter from "../../../SuperAdmin/Timesheet/common/CentersFilter";
import TextInput from "../../../UI/Inputs/TextInput";
import PositionsFilter from "./PositionsFilter";

interface SearchAndFilterProps {
  keyword: string;
  selectedCentreIds: number[];
  selectedPositionIds: number[];
  onKeywordChange: (value: string) => void;
  onCentreIdsChange: (ids: number[]) => void;
  onPositiondsChange: (ids: number[]) => void;
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
  keyword,
  selectedCentreIds,
  selectedPositionIds,
  onKeywordChange,
  onCentreIdsChange,
  onPositiondsChange,
}) => {
  const allCentersList = useSelector((state) => state.candidateJobs.candidateCentres);
  const allPositionList = useSelector(
    (state) => state.vacancy.positions
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onKeywordChange(e.target.value);
  };

  const searchInput = (
    <TextInput
      placeholder="Search..."
      field="search"
      value={keyword}
      onChange={handleSearchChange}
      showSearchIcon={true}
      floatingLabel={false}
    />
  );

  const handleCentreSelect = (centreIds: number[]) => {
    onCentreIdsChange(centreIds);
  };

  const handlePositionSelect = (positionIds: number[]) => {
    onPositiondsChange(positionIds);
  };

  return (
    <div className="d-flex flex-column flex-lg-row gap-10 align-items-lg-center justify-content-lg-between">
        <div className="form-group w-200px mobile-w-100 input-icon icon-left">
          {searchInput}
        </div>      
      <div className="d-flex flex-column flex-lg-row gap-20 gap-mobile-10 align-items-lg-center fs-13 fw-400">
        {allCentersList.length > 0 && (
          <div className="d-flex gap-3 align-items-center position-relative">
            <div className="fs-13 fw-400 text-black">Centres</div>
            <CentersFilter
              selectedCentreIds={selectedCentreIds}
              setSelectedCentreIds={(ids) => handleCentreSelect(ids)}
            />
          </div>
        )}
        {allPositionList.length > 0 && (
          <div className="d-flex gap-3 align-items-center position-relative">
            <div className="fs-13 fw-400 text-black">
              Positions
            </div>
            <PositionsFilter
              selectedPositionIds={selectedPositionIds}
              setSelectedPositionIds={(ids) => handlePositionSelect(ids)}
            />            
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
